const styles = theme => ({
  trackingItemRow: {
    borderBottom: '1px solid #E6E8E9',
    paddingTop: theme.spacing.unit * 3.25,
    paddingBottom: theme.spacing.unit * 3.25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  menuButtonContainer: {
    justifyContent: 'flex-end',
    alignContent: 'center',
    marginLeft: theme.spacing.unit * 1.5
  },
  emailAddress: {
    width: '100%',
    paddingLeft: theme.spacing.unit * 2,
    marginBottom: '0 !important',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },

  menuButton: {
    padding: 0,
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  linkIcon: {
    color: 'rgba(12,31,44,0.38)'
  },
  emailToolTip: {
    position: 'relative',
    top: 12,
    left: 12
  },
  resendTrackingLink: {
    paddingLeft: '0 !important',
    textTransform: 'none',
    textDecoration: 'underline',
    color: '#00A1FB !important',
    '&:hover': {
      backgroundColor: '#fff',
      textDecoration: 'underline'
    }
  }
});
export default styles;
